<template>
  <div data-toggle="sticky-onscroll">
    <meta name="imgUrl" :content="`${IMAGEURL}`" />

    <header class="header">
      <div class="container">
        <div
          class="d-flex justify-content-between top-logos align-items-center"
        >
          <div class="logo-text flex-lg-fill">
            <TextLogo></TextLogo>
          </div>

          <div class="flex-lg-fill align-items-center">
            <div>
              <div
                class=" d-flex justify-content-between flex-lg-fill"
              >
                <div class="search-box flex-lg-fill align-items-center mr-2">
                  <form
                    class="form-inline pr w-100"
                    :action="`${baseUrl}book-search`"
                    method="GET"
                  >
                    <input
                      class="form-control border-right-0 border top-search"
                      type="search"
                      name="keyword"
                      autocomplete="off"
                      placeholder="বইয়ের নাম, লেখক বা বই নিয়ে যে কোনো শব্দ লিখে অনুসন্ধান করুন"
                      v-model="keyword"
                      @keyup="autoSearch"
                    />
                    <img
                      src="/assets/img/search.ico"
                      class="search-box-icon"
                      alt=""
                    />
                    <AutoSearch
                      :autoProducts="autoProducts"
                      :currentPage="currentPage"
                      :autoSearchLoading="autoSearchLoading"
                    ></AutoSearch>
                  </form>
                </div>

                <div class="cart-login">
                  <router-link
                    v-if="!user_id"
                    to="/login"
                    class="btn btn-primary btn-wide"
                  >
                    <img src="/assets/img/login.ico" alt="" />
                    সাইন ইন
                  </router-link>
                  <router-link
                    v-else
                    :to="{ name: 'profile' }"
                    class="btn btn-primary btn-wide ml-1"
                  >
                    <i class="far fa-user"></i> অ্যাকাউন্ট
                  </router-link>

                  <router-link
                    to="/cart"
                    class="ml-2 ml-lg-2 position-relative btn btn-primary btn-wide"
                  >
                    <img src="/assets/img/cart.ico" alt="" /> কার্ট
                    <span class="cart-count">{{ $helper.cartCount() }}</span>
                  </router-link>
                </div>

                <div class="ml-2 d-block d-md-none">
                  <a
                    href="javascript:;"
                    data-toggle="collapse"
                    data-target="#navbarHover"
                    class="mobile-nav"
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                  </a>
                </div>

                <!--  -->
              </div>
            </div>
            <div class="text-right mt-3">
              <div>
                <a class="text-black" :href="`tel:${contact[0].short_description}`" target="_blank" rel="noopener">
                  <i class="fa fa-phone"></i>
                  {{ contact[0].short_description }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="mobile-search d-block d-md-none">
          <form
            class="form-inline pr"
            :action="`${baseUrl}book-search`"
            method="GET"
          >
            <input
              class="form-control border-right-0 border top-search"
              type="search"
              name="keyword"
              autocomplete="off"
              placeholder="বইয়ের নাম, লেখক বা বই নিয়ে যে কোনো শব্দ বাংলা বা ইংরেজিতে লিখে অনুসন্ধান করুন"
              v-model="keyword"
              @keyup="autoSearch"
            />
            <AutoSearch
              :autoProducts="autoProducts"
              :currentPage="currentPage"
              :autoSearchLoading="autoSearchLoading"
            ></AutoSearch>
          </form>
        </div>
      </div>
    </header>

    <div class="container">
      <nav class="navbar navbar-expand-lg navbar-dark pl-0 pr-0">

        <div class="collapse navbar-collapse" id="navbarHover">
          <a
            href="javascript:;"
            data-toggle="collapse"
            data-target="#navbarHover"
            class="mobile-nav-close d-block d-md-none"
          >
            <i class="fa fa-times"></i>
          </a>
          <ul
            class="navbar-nav justify-content-between w-100 main-menu align-items-center"
          >
            <li class="nav-item top-menu-item text-left scroll-logo">
              <TextLogo></TextLogo>
            </li>
            <li
              v-for="(item, key) in customMenu"
              :key="key"
              v-bind:class="{
                'nav-item top-menu-item dropdown': true,
                megamenu: item.type === 'MEGAMENU',
              }"
            >
              <div v-if="item.type === 'MEGAMENU'" class="vertical-line2"></div>
              <div v-else class="vertical-line"></div>

              <a
                v-if="item.type == 'CATEGORY' && item.child.length < 1"
                class="nav-link"
                :href="`${baseUrl}category/${item.type_value}/newest`"
                :id="`menutwo${item.id}`"
              >
                {{ item.title }}
                <img src="/assets/img/down-arrow.ico" class="menu-da" alt="" />
              </a>
              <a
                v-else-if="item.type == 'CATEGORY' && item.child.length > 0"
                class="nav-link"
                :href="`${baseUrl}category/${item.type_value}/newest`"
                :id="`menutwo${item.id}`"
                data-toggle="dropdown"
              >
                {{ item.title }}
                <img src="/assets/img/down-arrow.ico" class="menu-da" alt="" />
              </a>
              <a
                v-else-if="item.type == 'URL'"
                :href="`${item.type_value}`"
                :id="`menutwo${item.id}`"
                :target="`${item.custom_field}`"
                class="nav-link"
              >
                {{ item.title }}
              </a>
              <a
                v-else-if="item.type == 'MEGAMENU'"
                :href="`${baseUrl}category`"
                :id="`menutwo${item.id}`"
                class="nav-link"
              >
                {{ item.title }}
                <img src="/assets/img/down-arrow.ico" class="menu-da" alt="" />
              </a>
              <a
                v-else
                class="nav-link"
                :href="`${baseUrl}page/${item.type_value}`"
                :id="`menutwo${item.id}`"
              >
                {{ item.title }}
              </a>

              <div
                v-if="item.child.length > 0"
                class="dropdown-menu single-menu"
                :aria-labelledby="`menuone${item.id}`"
              >
                <a
                  v-for="(subcategory, skey) in item.child"
                  :key="skey"
                  class="dropdown-item"
                  :href="`${baseUrl}category/${subcategory.id}/newest`"
                  >{{ subcategory.category_name }}</a
                >
              </div>

              <div
                v-if="item.type === 'MEGAMENU'"
                class="dropdown-menu"
                aria-labelledby="menuthree"
              >
                <div class="container">
                  <div class="row">
                    <div class="col-md-12 mt-2">
                      <ul class="nav mt-2">
                        <li
                          v-for="(row, k) in category"
                          v-bind:key="k"
                          class="nav-item col-lg-2"
                        >
                          <a
                            class="nav-link"
                            :href="`${baseUrl}category/${row.id}/newest`"
                            >{{ row.category_name }}</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import AutoSearch from "./AutoSearch.vue";
import TextLogo from "./TextLogo.vue";

export default {
  components: {
    AutoSearch,
    TextLogo,
  },
  data() {
    return {
      autoSearchLoading: false,
      productsData: null,
      contact: [
        {
          custom_field: null,
        },
      ],
      social: [],
      currentPage: null,
      user_id: null,
      popup: null,
      publishers: null,
      customer_id: null,
      customMenu: null,
      keyword: "",
      category: [],
      autoProducts: [],
      downloads: [
        {
          image: ``,
        },
      ],
    };
  },
  methods: {
    showHideSearchInput() {
      $(`#scrollSearchForm`).animate({
        width: `toggle`,
      });
    },
    goTo(where) {
      this.$helper.goTo(where);
    },
    getContact() {
      fetch(`${this.APIURL}cms-resources/Contact-Us`)
        .then((response) => response.json())
        .then((json) => (this.contact = json.data));
    },
    getSocial() {
      fetch(`${this.APIURL}cms-resources/Social-Links`)
        .then((response) => response.json())
        .then((json) => (this.social = json.data));
    },
    getCategory() {
      fetch(`${this.APIURL}category-resources`)
        .then((response) => response.json())
        .then((json) => (this.category = json.data));
    },
    getPublisher() {
      this.$http
        .get(`publishers-resources`)
        .then((response) => {
          this.publishers = response.data.data;
        })
        .catch((e) => {
          this.publishers = null;
        });
    },
    getCustomMenu() {
      this.$http
        .get(`customMenu`)
        .then((response) => {
          this.customMenu = response.data;
          //console.log("this.customMenu", this.customMenu);
        })
        .catch((e) => {
          this.customMenu = null;
        });
    },
    getPublisher() {
      this.$http
        .get(`publishers-resources`)
        .then((response) => {
          this.publishers = response.data.data;
        })
        .catch((e) => {
          this.publishers = null;
        });
    },
    logout() {
      this.$helper.logout();
    },
    async autoSearch() {
      $(".autoResult").show();
      if (!this.keyword) {
        this.autoSearchLoading = false;
        $(".autoResult").hide();
      }

      if (!this.productsData) {
        try {
          const response = await this.$http.get(
            "https://kathaprokash.com/products.json"
          );
          this.productsData = response.data;
        } catch (error) {
          console.error("Error loading data:", error);
          return;
        }
      }

      const lowerKeyword = this.keyword.toLowerCase();
      this.autoProducts = this.productsData.filter(
        (product) =>
          (product.product_name &&
            product.product_name.toLowerCase().includes(lowerKeyword)) ||
          (product.product_name_en &&
            product.product_name_en.toLowerCase().includes(lowerKeyword)) ||
          (product.author_name &&
            product.author_name.toLowerCase().includes(lowerKeyword)) ||
          (product.author_name_en &&
            product.author_name_en.toLowerCase().includes(lowerKeyword))
      );
    },
  },
  mounted() {
    this.getContact();
    this.getSocial();
    this.getCategory();
    this.getPublisher();
    this.getCustomMenu();
    if (localStorage.getItem(`user_id`) !== null) {
      //console.log(localStorage.getItem(`user_id`));
      this.user_id = localStorage.getItem(`user_id`);
    }

    $(window).scroll(function () {
      if ($(window).scrollTop() >= 300) {
        $(".navbar").addClass("fixed-header");
        $(".scroll-logo").show();
      } else {
        $(".navbar").removeClass("fixed-header");
        $(".scroll-logo").hide();
      }
    });
  },
};
</script>
